import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import VillagesPage from "@/pages/VillagesPage";
import CategoriesPage from "@/pages/CategoriesPage";
import WorkLogsPage from "@/pages/WorkLogsPage";
import InfrastructurePage from "@/pages/InfrastructurePage";
import InvestmentsPage from "@/pages/InvestmentsPage";
import PetitionsPage from "@/pages/PetitionsPage";
import InstitutionsPage from "@/pages/InstitutionsPage";
import ReportsPage from "@/pages/ReportsPage";
import UsersPage from "@/pages/UsersPage";
import VillageDetailPage from "@/pages/VillageDetailPage";
import MaterialsPage from "@/pages/MaterialsPage";
import VillagePrintPage from "@/pages/VillagePrintPage";
import SettingsPage from "@/pages/SettingsPage";
import AuditLogPage from "@/pages/AuditLogPage";
import BackupPage from "@/pages/BackupPage";
import VillageAuditPrintPage from "@/pages/VillageAuditPrintPage";
import ChangePasswordPage from "@/pages/ChangePasswordPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/giris" element={<LoginPage />} />
            <Route path="/sifre-degistir" element={<ProtectedRoute><ChangePasswordPage /></ProtectedRoute>} />
            <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/koyler" element={<ProtectedRoute><VillagesPage /></ProtectedRoute>} />
            <Route path="/koyler/:id" element={<ProtectedRoute><VillageDetailPage /></ProtectedRoute>} />
            <Route path="/koyler/:id/gecmis-yazdir" element={<ProtectedRoute><VillageAuditPrintPage /></ProtectedRoute>} />
            <Route path="/koyler/:id/yazdir" element={<ProtectedRoute><VillagePrintPage /></ProtectedRoute>} />
            <Route path="/malzemeler" element={<ProtectedRoute><MaterialsPage /></ProtectedRoute>} />
            <Route path="/kategoriler" element={<ProtectedRoute><CategoriesPage /></ProtectedRoute>} />
            <Route path="/calisma-kayitlari" element={<ProtectedRoute><WorkLogsPage /></ProtectedRoute>} />
            <Route path="/altyapi" element={<ProtectedRoute><InfrastructurePage /></ProtectedRoute>} />
            <Route path="/yatirimlar" element={<ProtectedRoute><InvestmentsPage /></ProtectedRoute>} />
            <Route path="/dilekceler" element={<ProtectedRoute><PetitionsPage /></ProtectedRoute>} />
            <Route path="/kurumlar" element={<ProtectedRoute><InstitutionsPage /></ProtectedRoute>} />
            <Route path="/raporlar" element={<ProtectedRoute><ReportsPage /></ProtectedRoute>} />
            <Route path="/islem-gecmisi" element={<ProtectedRoute><AuditLogPage /></ProtectedRoute>} />
            <Route path="/yedekleme" element={<ProtectedRoute><BackupPage /></ProtectedRoute>} />
            <Route path="/ayarlar" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
            <Route path="/kullanicilar" element={<ProtectedRoute adminOnly><UsersPage /></ProtectedRoute>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
